import styled from '@emotion/styled';
import InputMask from 'react-input-mask';

export const Calendar = styled.div`
  display: flex;
  .rdrCalendarWrapper {
    .rdrDayStartPreview,
    .rdrDayInPreview,
    .rdrDayEndPreview {
      background-color: ${({ theme }) => theme.button.background};
    }
    .rdrDayDisabled {
      // background-color: #f8f8f8;
      background-color: ${({ theme }) => theme.bgColors.secondary};
    }
    .rdrDayHovered {
      background-color: ${({ theme }) =>
        theme.dark ? theme.input.hovered : theme.button.background};
      .rdrDayStartPreview,
      .rdrDayInPreview,
      .rdrDayEndPreview {
        background-color: ${({ theme }) =>
          theme.dark ? theme.input.hovered : theme.button.background};
      }
    }

    background-color: ${({ theme }) => theme.bgColors.primary};
    color: ${({ theme }) => theme.colors.primary};

    .rdrDayNumber {
      > span {
        color: ${({ theme }) => theme.colors.primary};
      }
    }
    .rdrDayPassive .rdrDayNumber span {
      color: ${({ theme }) => (theme.dark ? '#555' : '#d5dce0')};
    }
    .rdrNextPrevButton {
      background-color: ${({ theme }) => (theme.dark ? '#7b7d7f' : '#eff2f7')};
    }
    .rdrMonthAndYearPickers {
      select {
        color: ${({ theme }) => theme.colors.primary};
      }
    }
  }
  .rdrDefinedRangesWrapper {
    background-color: ${({ theme }) => theme.bgColors.primary};

    .rdrInputRangeInput {
      color: ${({ theme }) => theme.colors.secondary};
      background-color: ${({ theme }) => theme.input.background};
      border: 0;
      box-shadow: ${({ theme }) => theme.input.boxShadow};
      &:hover {
        color: ${({ theme }) => theme.colors.secondary};
      }
    }
    .rdrStaticRanges {
      .rdrStaticRange {
        background-color: ${({ theme }) => theme.bgColors.primary};
        border-bottom: 1px solid ${({ theme }) => theme.input.border};
        &:hover .rdrStaticRangeLabel,
        &:focus .rdrStaticRangeLabel {
          background-color: ${({ theme }) => theme.bgColors.hovered};
        }

        .rdrStaticRangeLabel {
          color: ${({ theme }) => theme.colors.primary};
        }
      }
    }
  }
`;

export const DateTimePicker = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
`;

export const DateSide = styled.div`
  flex: 0 0 100px;
`;

export const TimeSide = styled.div`
  flex: 0 0 50px;
`;

export const Input = styled(InputMask)`
  width: 100%;
  border: none;
  // background-color: #f4f5f7;
  background-color: ${({ theme }) => theme.input.background};
  font-weight: 300;

  &:focus {
    outline: none;
  }
`;

export const TimePicker = styled.div`
  display: flex;
  padding: 4px;
`;

export const TimeList = styled.div`
  display: flex;
  flex-direction: column;
  width: 30px;
  max-height: 300px;
  overflow: scroll;

  ::-webkit-scrollbar {
    width: 0;
    background: transparent;
  }
`;

export const DatePickerTrigger = styled.div`
  display: flex;
  height: 40px;
  width: 150px;
  align-items: center;
  color: #535456;
  font-size: 14px;
  font-weight: 300;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
    Oxygen, Ubuntu, Cantarell, Fira Sans, DroidSans, Helvetica Neue !important;
  white-space: nowrap;
  cursor: pointer;
  padding: 0 10px;
  border-radius: 4px;
  border-width: 2px;
  // background-color: #f4f5f7;
  background-color: ${({ theme }) => theme.input.background};
  margin: 0;

  box-shadow: ${({ isInvalid, theme }) =>
    isInvalid ? theme.input.boxShadowError : theme.input.boxShadow};
  &:hover {
    box-shadow: ${({ theme }) => theme.input.boxShadowHovered};
  }
`;

DatePickerTrigger.displayName = 'DatePickerTrigger';

export const DatePickerCalendarIcon = styled.img`
  margin-left: 5px;
  height: 16px;
`;
export const DateTimePickerStory = styled.div`
  display: flex;
  justify-content: flex-start;
`;
